"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SectionItem = void 0;
var _basketItem = require("@ori/basket-item");
var _contexts = require("../../contexts");
var _useSectionItem = require("./useSectionItem");
var _jsxRuntime = require("react/jsx-runtime");
const SectionItem = (param)=>{
    let { item, mapperProps, actionsProps } = param;
    const { basketItem, splitoutData } = (0, _useSectionItem.useSectionItem)({
        item,
        mapperProps,
        actionsProps
    });
    const { loadingItem } = (0, _contexts.useBasketContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_basketItem.BasketItem, {
        ...basketItem,
        isLoading: basketItem.lineNumber === loadingItem || (splitoutData === null || splitoutData === void 0 ? void 0 : splitoutData.parentLineNumber) === loadingItem
    });
};
exports.SectionItem = SectionItem;
